module.exports = __webpack_public_path__ + "static/media/app_store_badge_us_white.7e45556f.svg";